<template>
  <div>
    <button
      type="button"
      class="btn btn-link"
      @click="act"
    >
      <i class="icon-pencil"></i>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'ColumnUpdate',
    props: ['row', 'column'],
    data: () => {
      return {}
    },
    methods: {
      act() {
        this.$emit('click',this.row);
      }
    },
    computed: {}
  }
</script>